import React from 'react';

type CounterInfoFieldProps = {
  value: string | React.ReactNode;
  size?: 'default' | 'large';
  label?: string;
  color?: string;
  showArrow?: boolean;
};

export const CounterInfoField: React.FC<CounterInfoFieldProps> = ({
  value,
  size = 'default',
  label,
  color = 'text-[#FFC107]',
  showArrow = true,
}) => {
  const textSize = size === 'large' ? 'text-3xl' : 'text-base';
  const arrowSize = size === 'large' ? 'text-2xl' : 'text-base';
  const labelClass = size === 'large' ? 'text-sm text-[#FFC107]' : 'text-sm font-medium break-words text-[#B2B2B2]';
  const gapClass = size === 'large' ? 'gap-2' : 'gap-1';

  const content = (
    <div className="flex items-center gap-2">
      {showArrow && <span className={`${color} ${arrowSize}`}>→</span>}
      <span
        className={`${color} ${textSize} font-medium break-words`}
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {value}
      </span>
    </div>
  );

  if (label) {
    return (
      <div className={`flex flex-col justify-start items-start ${gapClass}`}>
        <div
          className={labelClass}
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          {label}
        </div>
        {content}
      </div>
    );
  }

  return content;
};
